import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '../views/auth/login/LoginPage.vue';
import ForgotPasswordPage from "@/views/auth/restorePassword/ForgotPasswordPage.vue";
import ResetPasswordPage from "@/views/auth/restorePassword/ResetPasswordPage.vue";
import RegisterPage from "@/views/auth/registration/RegistrationFirstStepPage.vue";
import PrivacyPolicyPage from "@/views/PrivacyPolicyPage.vue";
import RegistrationForm from "@/views/auth/registration/RegistrationLastStepPage.vue";
import AnalyticsPage from "@/views/analytics/AnalyticsPage.vue";
import ProfilePage from "@/views/profile/ProfilePage.vue";
import AuthCallbackPage from "@/views/AuthCallback.vue";
import store from "@/store"
import RegistrationByEmailPage from "@/views/auth/registration/RegistrationByEmailPage.vue";
import PaymentLinkPage from "@/views/payment/PaymentLinkPage.vue";
import WordPressContentPage from "@/views/content/WordPressContentPage.vue";

const routes = [
    {
        path: '/',
        name: 'Home',
        component: LoginPage
    },
    {
        path: '/login',
        name: 'Login',
        component: LoginPage,
        meta: { unauthorizedOnly: true }
    },
    {
        path: '/register-first-step',
        name: 'Register',
        component: RegisterPage,
        meta: { unauthorizedOnly: true }
    },
    {
        path: '/register-confirm',
        name: 'RegistrationByEmail',
        component: RegistrationByEmailPage,
        meta: { unauthorizedOnly: true }
    },
    {
        path: '/forgot-password',
        name: 'Forgot password',
        component: ForgotPasswordPage,
        meta: { unauthorizedOnly: true }
    },
    {
        path: '/reset-password',
        name: 'Reset password',
        component: ResetPasswordPage
    },
    {
        path: '/privacy-policy',
        name: 'Privacy policy',
        component: PrivacyPolicyPage
    },
    {
        path: '/register',
        name: 'AccountCreation',
        component: RegistrationForm,
        meta: { requiresVerification: true }
    },
    {
        path: '/analytics',
        name: 'Analytics',
        component: AnalyticsPage,
        meta: { auth: true }
    },
    {
        path: '/profile',
        name: 'Profile',
        component: ProfilePage,
        meta: { auth: true }
    },
    {
        path: '/content/:slug?',
        name: 'Content',
        component: WordPressContentPage,
        meta: { auth: true }
    },
    {
        path: '/pay/:token',
        name: 'PaymentLink',
        component: PaymentLinkPage
    },
    {
        path: '/auth/callback',
        name: 'AuthCallback',
        component: AuthCallbackPage,
        meta: { unauthorizedOnly: true }
    }
];

const index = createRouter({
    history: createWebHistory(),
    routes,
});

index.beforeEach((to, from, next) => {
    const userInfo = store.getters['main/userInfo'];
    const isAuthenticated = Object.keys(userInfo).length > 0;

    if (to.meta.auth && !isAuthenticated) {
        return next({
            path: '/login',
            query: { redirect: to.fullPath }
        });
    }

    if (to.meta.unauthorizedOnly && isAuthenticated) {
        return next('/');
    }

    if ((to.path === '/login' || to.path === '/') && isAuthenticated) {
        return next('/analytics');
    }

    if (to.meta.requiresVerification) {
        return localStorage.getItem('isVerified') !== 'true' ? next('/') : next();
    }

    return next();
});


export default index;
